import { render } from "./DeliveryAreasEdit.vue?vue&type=template&id=39ea7e59"
import script from "./DeliveryAreasEdit.vue?vue&type=script&lang=js"
export * from "./DeliveryAreasEdit.vue?vue&type=script&lang=js"

import "./DeliveryAreasEdit.vue?vue&type=style&index=0&id=39ea7e59&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__